import React from 'react';
import Seal from '../assets/print/seal_corporate.png';
import Seal2 from '../assets/print/seal_general.png';
import Logo from '../assets/print/logo_corporate.png';
import Logo2 from '../assets/print/logo_general.png';
import moment from 'moment';
import { Get as GetConfig } from '../view/basic/http';

const day = ['일', '월', '화', '수', '목', '금', '토'];

class Bill extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            config: {
                phone: '',
                tel: '',
                fax: '',
                email: '',
                addr: '',
                office: '',
                account: '',
                phone2: '',
                tel2: '',
                fax2: '',
                email2: '',
                addr2: '',
                office2: '',
                account2: '',
            },
        };

        GetConfig(this, res => {
            this.setState({ config: res });
        });
    }

    render() {
        const { config } = this.state;
        const { data, type } = this.props;

        return (
            <div className="print_content">
                <div className="content">
                    <img className={type === 1 ? 'logo' : 'logo2'} src={type === 1 ? Logo : Logo2} />
                    <div className="title">한국분동 주식회사</div>
                    <div className="sub_title">
                        <span className="title">{type === 1 ? 'Korea Weight' : 'HAN KUK Weight'}</span>
                        <span className="date">{moment().format('YY. MM. DD') + ' (' + day[moment().day()] + ')'}</span>
                    </div>
                    <div className="table_page_info">
                        <table>
                            <colgroup>
                                <col width="100" />
                                <col width="500" />
                                <col width="100" />
                                <col width="500" />
                            </colgroup>
                            <tr>
                                <td>문서번호</td>
                                <td>한국분동 {moment().format('YY-MM-DD')}</td>
                                <td>휴&nbsp;&nbsp;대&nbsp;&nbsp;폰</td>
                                <td>{data.phone}</td>
                            </tr>
                            <tr>
                                <td rowSpan="2">수&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;신</td>
                                <td rowSpan="2">{data.buld_nm} 관리소장님 귀하</td>
                                <td>전&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;화</td>
                                <td>{data.ledg_mnfctur_hedofc_telno}</td>
                            </tr>
                            <tr>
                                <td>팩&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;스</td>
                                <td>{data.fax}</td>
                            </tr>
                            <tr>
                                <td rowSpan="2">발&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;신</td>
                                <td rowSpan="2">한국분동(주)</td>
                                <td>전&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;화</td>
                                <td>{type === 1 ? config.phone : config.phone2}</td>
                            </tr>
                            <tr>
                                <td>사&nbsp;&nbsp;무&nbsp;&nbsp;실</td>
                                <td>{type === 1 ? config.office : config.office2}</td>
                            </tr>
                            <tr>
                                <td>제&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;목</td>
                                <td colSpan="4">분동지원 내역</td>
                            </tr>
                        </table>
                    </div>
                    <div className="list">
                        <ul>
                            <li>1. 귀 사의 무궁한 발전을 기원합니다.</li>
                            <li>2. 요청하신 분동 지원과 관련하여 아래와 같이 알려드리오니 입금 후 연락 부탁드립니다.</li>
                        </ul>
                        <ul className="sub">
                            <li>가. 검사일정 : {moment(data.inspct_dt).format('YYYY - MM - DD  HH : mm')}</li>
                            {/* <li>나. 호기정보 : {data.elevatorId} {data.recptn_cnt} 대</li> */}
                            <li>나. 호기정보 : {data.elevatorId} </li>
                            {/* <li>나. 호기정보: 00915-04외 1대</li> */}
                            <li>다. 검사종류 : {data.inspct_kind_nm}</li>
                            <li>라. 장소 및 용량</li>
                        </ul>
                    </div>
                    <div className="table_list">
                        <table className="tbl_board small">
                            <colgroup>
                                <col width="200" />
                                <col width="400" />
                                <col width="200" />
                                <col width="100" />
                                <col width="200" />
                                <col width="200" />
                                <col width="200" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>건물명</th>
                                    <th>주소</th>
                                    <th>용량(kg)</th>
                                    <th>수량</th>
                                    <th>단가(원)</th>
                                    <th>공급가액</th>
                                    <th>부가세</th>
                                </tr>
                            </thead>
                            <tr>
                                <td>{data.buld_nm}</td>
                                <td>{data.address}</td>
                                <td>{data.ledg_live_load}</td>
                                <td>{data.recptn_cnt}</td>
                                <td>{data.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                <td>{(data.recptn_cnt * data.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                <td>
                                    {Math.floor(data.recptn_cnt * data.price * 0.1)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </td>
                            </tr>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th>합계</th>
                                    <th></th>
                                    <th>{data.recptn_cnt}</th>
                                    <th></th>
                                    <th colSpan="2">
                                        {Math.floor(data.recptn_cnt * data.price * 1.1)
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </th>
                                </tr>
                            </tfoot>
                        </table>

                        <div className="list">
                            <ul className="sub">
                                <li>마. 입금계좌 : {type === 1 ? config.account : config.account2}</li>
                                <li>바. 현장 담당자 : </li>
                            </ul>
                        </div>
                    </div>

                    <div className="empty" />

                    <div className="footer_title">
                        {type === 1 ? '한국분동(주)대표이사' : '한 국 분 동 대 표'}
                        <img src={type === 1 ? Seal : Seal2} />
                    </div>
                    <div className="footer">
                        <div>
                            <span>{type === 1 ? config.addr : config.addr2}</span>
                        </div>
                        <div>
                            <span>TEL : {type === 1 ? config.tel : config.tel2}</span>
                            <span>FAX : {type === 1 ? config.fax : config.fax2}</span>
                            <span>E-mail : {type === 1 ? config.email : config.email2}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Bill;
